import React from 'react';
import PageSection from '../../components/PageSection';
import { Route, Routes } from 'react-router-dom';
import { useAPI } from '../../api';
import DataTable from '../../components/DataTable';
import FirewallContainer from './FirewallContainer';
import { Firewall } from 'types';
import { OrgContextLink, useOrgContext } from 'components/OrgContextProvider';

const FirewallsContainer = () => {
	const api = useAPI();
	const ctx = useOrgContext();

	const [firewalls, setFirewalls] = React.useState<Firewall[]>([]);

	const loadFirewalls = () => {
		api.get<Firewall[]>(`${ctx?.apiBaseTenant}/firewalls`)
		.then(json => setFirewalls(json));
	};

	React.useEffect(() => {
		if (ctx?.tenantID) {
			loadFirewalls();
		} else {
			setFirewalls([]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ctx?.tenantID]);

	function deleteFirewall(firewallID: string) {
		if (window.confirm(`Delete firewall ${firewallID}?`)) {
			api.delete(`${ctx?.apiBaseTenant}/firewalls/${firewallID}`)
			.then(loadFirewalls);
		}
	};

	function deleteFirewallForce(firewallID: string) {
		if (window.confirm(`Delete firewall ${firewallID} (force)?`)) {
			api.delete(`${ctx?.apiBaseTenant}/firewalls/${firewallID}?force=true`)
			.then(loadFirewalls);
		}
	};

	return !ctx?.tenantID ? (
		<p>Select a tenant from the selector above.</p>
	) : (
		<div>
			<PageSection title="Firewalls" level={2} />

			<Routes>
				<Route path="/" element={
					<div>
						<PageSection title="Firewalls">
							<DataTable<Firewall>
								data={firewalls}
								columns={[
									{ label: 'Name', key: 'name', render: (firewall) => (<OrgContextLink to={`/settings/firewalls/${firewall.id}`}>{firewall.name}</OrgContextLink>) },
									{ label: 'ID', key: 'id' },
									{ label: 'Type', key: 'type' },
									{ label: 'Address', key: 'address' },
								]}
								tools={[
									{ label: 'Delete', action: (firewall) => deleteFirewall(firewall.id!) },
									{ label: 'Delete (Force)', action: (firewall) => deleteFirewallForce(firewall.id!) }
								]}
								tableTools={[
									{ label: 'New Firewall', render: () => (<OrgContextLink to={`/settings/firewalls/new`}>New Firewall</OrgContextLink>) }
								]}
							/>
						</PageSection>
					</div>
				} />
				<Route path="/:firewallID" element={<FirewallContainer onChanged={loadFirewalls} />} />
			</Routes>
		</div>
	);
};

export default FirewallsContainer;